import { GetterTree } from 'vuex'
import RootState from '@vue-storefront/core/types/RootState'
import UserState from '../../types/UserState'

const getters: GetterTree<UserState, RootState> = {
  getUserStatus: state => state.user_status,
  isUserExist: state => state.user_status === 'exists',
  isUserInvited: state => state.user_status === 'invite',
  isUserValidationFailed: state => state.user_status === 'user validation failed',
  getCards: state => state.cards,
  getDefaultCreditCard: state => state.cards.find(c => c.is_default),
  showOtpModal: state => state.otp_modal,
  getFee: state => state.ipay_fee,
  isFeeLoading: state => state.fee_calculation_running,
  getIPayActionLink: state => state.ipay_link,
  isRegisterLinkLoading: state => state.ipay_link_running
}

export default getters
